<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">THE MOORS</span></h1>
<h1 class="title1"><span class="bold">MURDERERS</span></h1>
<p class="subtitle"><span class="bold">THE FULL STORY OF IAN BRADY AND MYRA HINDLEY</span></p>
<p class="author"><span class="bold">C.G.C. COOK</span></p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?081ca22f